import React from 'react';
import { IRoomsOperatorsJobResult, IRoomsOperatorsUploadJobDetails } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { AlertErrorMessage } from '../../global/modal/alerts-host/types/alert/alert-error-message';

const operatorsUploadJobProperties : IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IRoomsOperatorsUploadJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IRoomsOperatorsUploadJobDetails, IRoomsOperatorsJobResult>) => {
        const { result } = props;
        if (!result) return <>Upload complete</>;
        const { duplicatedEmails, notFoundEmails, addedCount, roomsCount } = result;

        return (
            <div className='alert-content'>
                <div>Upload complete. {addedCount} operators were added to {roomsCount} rooms.</div>
                { !!notFoundEmails.length && <div>
                    <br/>
                    <div>The below email addresses could not be found:</div>
                    {notFoundEmails.map(email => <div key={email}>{email}</div>)}
                </div>}
                { !!duplicatedEmails.length && <div>
                    <br/>
                    <div>The below email addresses have duplicate Users associated to them. Please remove the duplicates and try again.</div>
                    {duplicatedEmails.map(email => <div key={email}>{email}</div>)}
                </div>}
            </div>
        );
    },
    failedComponent: (props: IJobResultComponentProps<IRoomsOperatorsUploadJobDetails, IRoomsOperatorsJobResult>) => {
        return <AlertErrorMessage title='Operators Upload Failed' message={props.result?.errorMessage || 'Unknown failure reason'} />;
    },
};

export { operatorsUploadJobProperties };
